import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_PROMOTION_TYPES,
  FETCH_PROMOTION_TYPE,
} from "../actions/promotionType";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false,
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
};

export function promotionTypes(
  state = MULTI_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_PROMOTION_TYPES}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PROMOTION_TYPES}_${FULFILLED}`:
      return Object.assign({}, state, payload, {
        loading: false,
        error: null,
      });
    case `${FETCH_PROMOTION_TYPES}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function promotionType(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_PROMOTION_TYPE}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PROMOTION_TYPE}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${FETCH_PROMOTION_TYPE}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
